'use client';

/* empty css                           */
var pressed = "c5-25-0_wz5v3f0";
export {
  pressed
};
